var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$options.name}},[_c('v-row',{staticClass:"mt-n4"},[_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12"}},[_c('a-rms-strategy-weeks',{ref:"a-rms-strategy-weeks",attrs:{"event_period":_vm.event_period}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }